import classes from './InfoBanner.scss';
import classess from '../../../Centralized/CPCGuest/GuestBPSearch/guestBPSearch.scss';
import ReactHtmlParser from 'react-html-parser';

const InfoBanner = (props) => {

  const getInfoProps = (type) => {
    const warningHexIcon = drupalSettings.path.baseUrl + 'sites/default/files/react_images/Warning--hex.svg';
    const warningIcon = drupalSettings.path.baseUrl + 'sites/default/files/react_images/Warning--alt.png';
    const successIcon = drupalSettings.path.baseUrl + 'sites/default/files/react_images/Checkmark--outline.svg';
    const informationIcon = drupalSettings.path.baseUrl + 'sites/default/files/react_images/Information.svg';
    const warningIconTriangle = drupalSettings.path.baseUrl + 'sites/default/files/react_images/Warning--alt.svg';
    let infoProps;
    if(props.scrollTop){
      window.scrollTo(0,0);
    } 
    switch(type){
      case 'warning':
        infoProps = {
          style: classes.paErrorBlock + " " + classes.errorBackground,
          icon: warningIcon
        };
        return infoProps;
      case 'success':
        infoProps = {
          style: classes.paErrorBlock + " " + classes.succussBackground,
          icon: successIcon
        };
        return infoProps;
      case 'warning-hex':
        infoProps = {
          style: classes.paErrorBlock + " " + classes.warringHexBackground,
          icon: warningHexIcon
        };
        return infoProps;
        case 'info':
          infoProps = {
            style: classes.paErrorBlock + " " + classes.infoBackground,
            icon: informationIcon
          };
          return infoProps;
          case 'warningTriangle':
          infoProps = {
            style: classes.paErrorBlock + " " + classes.errorBackground,
            icon: warningIconTriangle
          };
          return infoProps;
      default:
        infoProps = {
          style: classes.paErrorBlock + " " + classes.succussBackground,
          icon: successIcon
        };
        return infoProps;
    }
  };

  return (
    <div className={classes.paErrorContainer}>
      <div className={props.primaryType === "warning-hex" ? classess.SRErrorClass +' '+ classes.infoBannerError +' '+  getInfoProps(props.primaryType).style :  getInfoProps(props.primaryType).style}>
        <div className={classes.paErrorWarning}>
          <div className={classes.paErrorHeadingWrapper}>
            <img alt='checkIcon' src={getInfoProps(props.primaryType).icon} className={classes.infoIcon} />
            <div className={classes.paWarningHeadingWrapper}>
              {
                props.isNotBold ?
                <div className={classes.termsAndConditionError}>{props.primaryHeader}</div> :
                <div className={classes.paErrorHeading+ ' ' + props.className}><strong>{props.primaryHeader}</strong></div>
              }
              {/* <div className={props.isNotBold?classes.termsAndConditionError:(classes.paErrorHeading+ ' ' + props.className)}><strong>{props.primaryHeader}</strong> */}
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className={classes.paErrorSubHeadingWrapper}>
          <div className={classes.paErrorSubHeading}>
            {props.primaryMessage}
          </div>
        </div>
      </div>
      {props.secondaryType && <div className={props.secondaryType === "warning-hex" ? classess.SRErrorClass +' '+ classes.infoBannerError +' '+  getInfoProps(props.secondaryType).style :  getInfoProps(props.secondaryType).style}>
        <div className={classes.paErrorWarning}>
          <div className={classes.paErrorHeadingWrapper}>
            <img alt='checkIcon' src={getInfoProps(props.secondaryType).icon} />
            <div className={classes.paWarningHeadingWrapper}>
              <div className={classes.paErrorHeading}><strong> {props.secondaryHeader}</strong>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.paErrorSubHeadingWrapper}>
          <div className={classes.paErrorSubHeading}>
            {props.secondryMessage}
          </div>
        </div>
      </div>}
    </div>

  );
};
export default InfoBanner;
